module.exports = __webpack_public_path__ + "img/index_yxkl.baf7c17a.svg";